import { APPSTORE_URL, PLAYSTORE_URL } from "../../constants";
import { Button } from "../button";

export const CTA = () => {
  return (
    <div
      className="
          bg-cover lg:bg-center
          bg-deep-primary
          relative
          "
    >
      <img
        src="/assets/images/landscape.png"
        className="absolute inset-0 block object-cover object-left w-full h-full"
        alt="landscape"
        style={{
          opacity: 1,
          mixBlendMode: "color-burn",
        }}
      />

      <div
        className={`
        max-width
        flex flex-col md:flex-row lg:items-center justify-between
        gap-14 py-[56px] lg:py-[80px] z-10
        `}
      >
        <p
          className="
          text-white
          w-full max-w-[535px]
          font-medium text-[32px] lg:text-[42px] leading-[36px] lg:leading-[52px]
        "
        >
          Download <span className="text-yellow font-bold">MyCardGlobal</span> today
          and revolutionize your financial journey
        </p>

        <div className="flex items-center gap-4 flex-wrap w-full lg:max-w-fit">
          <Button
            className="max-w-fit"
            text={"Get on Android"}
            icon="playstore-colored"
            variation="white"
            onClick={() => {
              window.location.href = PLAYSTORE_URL;
            }}
          />

          <Button
            className="max-w-fit"
            text={"Get on Apple"}
            icon="apple"
            variation="white"
            onClick={() => {
              window.location.href = APPSTORE_URL;
            }}
          />
        </div>
      </div>
    </div>
  );
};
